// SCR-230/231's routes (NAV-019): an org's quotas and one quota's standing, grants and history, in
// the AllCode admin under the customer (tab at `/customers/:orgId`). The screens are the library's
// (`@nexus/ui/screens/quotas`, ADR-101); pages.tsx frames them for this shell. The proxy's Admin
// area mounts the same screens itself (TASK-588), so there is no console route table here any
// more. Who may read is the server's (an org admin, `reports:read`, `billing:read`); the screens
// resolve the org through the org context, which refuses another org's route to a customer, so the
// routes need a session. The fleet overview (`/quotas`, SCR-234, TASK-253) is AllCode staff's alone
// (`billing:read`).
import { defineRoute, type ScreenRoute } from "../../router/route";
import { FleetPage } from "./fleet";
import { FLEET_PATH, FLEET_TITLE } from "./fleet-model";

// `/customers/:orgId/quotas[/:quotaId]` are the customer page's Quotas tab (REQ-238): the
// customer routes (`:tab`, `:tab/:subtab`) resolve them to `CustomerPage`, under its tab bar.
export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-019", path: FLEET_PATH, title: FLEET_TITLE, permission: "billing:read", component: FleetPage }),
];
